module.exports = __webpack_public_path__ + "static/img/图层 508.78f33d54.png";